
import { Flex} from '@chakra-ui/react'
import React from 'react'
import { Line } from 'react-chartjs-2'
import StatBox from '../StatBox';


export default function ChartBox(props) {

    const labels = ["1", "2", "3", "4", "5", "6", "7"];
    const data = {
        labels: labels,
        datasets: [{
            label: 'Crianças Acolhidas',
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
        }]
    };

    return (
        <Flex direction={["column", "row" ]} w="100%"
            p={[2,10]}
            backgroundColor="white"
            h={["auto",400]}
            my={[5]}
            rounded="lg"
            boxShadow="md">
            <Flex className="chart"
                w={["100%","60%"]}
                mr={5}>
                <Line
                    data={data}
                    width={props.width}
                    height={props.height}
                    options={{
                        maintainAspectRatio: false
                    }}
                />
            </Flex>
            <Flex w={[ "100%","40%"]} direction="column" maxH="400px">
                <Flex direction="column" maxW="100%" pt={2}>
                    <StatBox label="Por ocorrencia" value="47"  divider />
                    <StatBox label="Acolhido a mais de 1 ano" value="33" divider />
                    <StatBox label="Sem o Plano de atendimento individual" value="33" divider />
                    <StatBox label="Sem visitas a 2 meses" value="21" divider />
                    <StatBox label="Desligados (últimos 60 dias)" value="47" />
                </Flex>
            </Flex>
        </Flex>
    )
}
